<template>
  <content-wrapper :title="labels.LBL_BANNERS" back>
    <template slot="actions">
      <el-button size="small" type="success" @click="submitForm('bannerForm')">
        <i class="el-icon-check mr-1"></i>
        Save
      </el-button>
    </template>

    <el-form
      v-loading="loading"
      ref="bannerForm"
      :model="banner"
      :rules="rules"
      label-position="top"
    >
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item prop="image" :label="labels.LBL_PHOTO">
            <UploadImage v-model="banner.image" :expand="true" />
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item prop="title" :label="labels.LBL_TITLE">
            <el-input v-model="banner.title"></el-input>
          </el-form-item>
        </el-col>

        <!-- <el-col :span="8">
          <el-form-item label="Link Url">
            <el-input v-model="banner.link"></el-input>
          </el-form-item>
        </el-col> -->

        <el-col :span="8">
          <el-form-item :label="labels.LBL_PUBLISH_BANNER">
            <el-switch v-model="banner.is_published"></el-switch>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </content-wrapper>
</template>

<script>
  import { mapState } from "vuex";
  import { labels, rules } from "@/common";
  import Banner from "@/models/banner";
  import ContentWrapper from "@/components/layouts/AdminContentWrapper.vue";
  import UploadImage from "@/components/UploadImage";

  export default {
    name: "AddBanner",

    components: {
      ContentWrapper,
      UploadImage,
    },

    data() {
      return {
        labels,
        rules,

        banner: new Banner(),
      };
    },

    computed: {
      ...mapState({ loading: (state) => state.isBusy }),
    },

    methods: {
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$store.dispatch("banner/createBanner", this.banner);
          }
        });
      },
    },
  };
</script>

<style></style>
